import React from 'react';
import PropTypes from 'prop-types';
import { ListItem, Typography } from '@sm/wds-react';

import './Submenu/nav-submenu.scss';

export const SubMenuItem = ({ subTitle, title, url, openInNewWindow }) => {
  return (
    <ListItem
      key={title}
      className="sm-nav-submenu__list-item"
      isNavigable
      navigationTarget={url}
      {...(openInNewWindow === true && {
        target: '_blank',
        rel: 'noopener noreferrer',
      })}
    >
      <Typography
        variant="cardTitle"
        color="link"
        className="sm-nav-submenu__product-title"
      >
        {title}
      </Typography>
      <p className="sm-nav-submenu__product-subtitle">{subTitle}</p>
    </ListItem>
  );
};

export default SubMenuItem;

SubMenuItem.propTypes = {
  subTitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  openInNewWindow: PropTypes.bool,
};

SubMenuItem.defaultProps = {
  openInNewWindow: false,
};
